 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"assignment":"assignment","couriers":"couriers","home":"home","login":"login","packAndDispatch":"packAndDispatch","print":"print","tasks":"tasks","users":"users"}[chunkId]||chunkId) + "-legacy." + {"assignment":"e56d69c7","chunk-7a2e2b2e":"e8505a26","couriers":"9be1cabb","home":"1d43b4a6","login":"48871298","packAndDispatch":"a4e11a63","print":"ded2b126","tasks":"c4dc6a28","users":"38d64240","chunk-0d8f431b":"5c24cb6b","chunk-0f90a0b9":"2bb4e880","chunk-896e08de":"57a4e038","chunk-1d022c1d":"e47b1b67","chunk-2134993b":"7b7aa228","chunk-67537ae8":"ca33ca4f","chunk-a0906d5c":"9f51c31c","chunk-277c4a2a":"ccd6510e","chunk-2d0cb77d":"86c5ae35","chunk-3041ddba":"03091133","chunk-341a24db":"fe144993","chunk-70545f0d":"ab495fc0","chunk-8b0b7e68":"c7fe939c","chunk-101cafff":"a8ea671d","chunk-6e6a92cd":"737c9f56","chunk-7859f8ee":"e0aeba46","chunk-a88f766a":"4648334f","chunk-d07e4454":"5286419c","chunk-1b22978c":"39bb0876","chunk-5ddf60b2":"7bef6c5a","chunk-02d758f7":"012a66be","chunk-29f75fd8":"0ff62d12","chunk-6dcef839":"13e91dde","chunk-7fc63644":"40ecf08d","chunk-af9342ac":"f020310e","chunk-ed4f4616":"2c3945ce","chunk-6fc3c588":"cbe550f4","chunk-c8b90bfa":"56c536fd","chunk-0ec3ebb3":"28b6f20d","chunk-5cbd1fcf":"f561385b","chunk-48385e80":"91203eab","chunk-526b84f4":"8330c1a2","chunk-5abfcafa":"25d804be","chunk-74d8a068":"d6c08ab5","chunk-12bcd520":"4e98ad5c","chunk-68bbc849":"180355e3","chunk-cd1faea6":"8631d8ac","chunk-17fa4e38":"82b70b33","chunk-2d0aa995":"efed240a","chunk-2bf51d38":"25ecf013","chunk-6b3b21a4":"efda528d","chunk-2f416124":"77c31bbf","chunk-6d21b2ba":"1fd4a380","chunk-5c8cc8ee":"cc6e276d","chunk-36c8e184":"aa9b5f76","chunk-2d22b923":"82af5cb5","chunk-3493d2b9":"253138c4","chunk-2d0abe78":"c8ef59be","chunk-04ea26de":"7109c4d6","chunk-70f339e8":"ae0ce4e6","chunk-d4ee8400":"c07c0ad6","chunk-76cc7496":"8351b0ba","chunk-2d0a4638":"68039572","chunk-0e579ad4":"a7ab6482","chunk-28a9a91a":"8e972860","chunk-2c9e7ee5":"9e51f04a","chunk-2d2084ab":"689aa048"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"assignment":1,"chunk-7a2e2b2e":1,"couriers":1,"home":1,"login":1,"packAndDispatch":1,"print":1,"tasks":1,"users":1,"chunk-0d8f431b":1,"chunk-0f90a0b9":1,"chunk-896e08de":1,"chunk-1d022c1d":1,"chunk-67537ae8":1,"chunk-a0906d5c":1,"chunk-277c4a2a":1,"chunk-3041ddba":1,"chunk-70545f0d":1,"chunk-8b0b7e68":1,"chunk-101cafff":1,"chunk-a88f766a":1,"chunk-d07e4454":1,"chunk-1b22978c":1,"chunk-5ddf60b2":1,"chunk-02d758f7":1,"chunk-29f75fd8":1,"chunk-6dcef839":1,"chunk-7fc63644":1,"chunk-af9342ac":1,"chunk-6fc3c588":1,"chunk-c8b90bfa":1,"chunk-0ec3ebb3":1,"chunk-5cbd1fcf":1,"chunk-48385e80":1,"chunk-526b84f4":1,"chunk-5abfcafa":1,"chunk-74d8a068":1,"chunk-12bcd520":1,"chunk-68bbc849":1,"chunk-cd1faea6":1,"chunk-17fa4e38":1,"chunk-2bf51d38":1,"chunk-6b3b21a4":1,"chunk-2f416124":1,"chunk-6d21b2ba":1,"chunk-5c8cc8ee":1,"chunk-36c8e184":1,"chunk-3493d2b9":1,"chunk-04ea26de":1,"chunk-d4ee8400":1,"chunk-76cc7496":1,"chunk-0e579ad4":1,"chunk-28a9a91a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"assignment":"assignment","couriers":"couriers","home":"home","login":"login","packAndDispatch":"packAndDispatch","print":"print","tasks":"tasks","users":"users"}[chunkId]||chunkId) + "." + {"assignment":"e0a32f37","chunk-7a2e2b2e":"ee21a07f","couriers":"895d45df","home":"07e38327","login":"3ef3b617","packAndDispatch":"e6025e8b","print":"16884cb5","tasks":"801a0444","users":"9528fb89","chunk-0d8f431b":"83fcf3e8","chunk-0f90a0b9":"188e04d6","chunk-896e08de":"5306ed26","chunk-1d022c1d":"5fbae0cc","chunk-2134993b":"31d6cfe0","chunk-67537ae8":"e9021092","chunk-a0906d5c":"c0a38d4f","chunk-277c4a2a":"ea94691a","chunk-2d0cb77d":"31d6cfe0","chunk-3041ddba":"6a853357","chunk-341a24db":"31d6cfe0","chunk-70545f0d":"448fb87f","chunk-8b0b7e68":"5d83e41e","chunk-101cafff":"70718cfb","chunk-6e6a92cd":"31d6cfe0","chunk-7859f8ee":"31d6cfe0","chunk-a88f766a":"ec6a5260","chunk-d07e4454":"ce0f92f3","chunk-1b22978c":"a51a0626","chunk-5ddf60b2":"22c28f6d","chunk-02d758f7":"6691dedc","chunk-29f75fd8":"5f0f9cb3","chunk-6dcef839":"d901948a","chunk-7fc63644":"f1302d0c","chunk-af9342ac":"3e53b703","chunk-ed4f4616":"31d6cfe0","chunk-6fc3c588":"c17e70b8","chunk-c8b90bfa":"dc3b6651","chunk-0ec3ebb3":"1fd2f67b","chunk-5cbd1fcf":"b863e9d0","chunk-48385e80":"244f2cdf","chunk-526b84f4":"fe999a28","chunk-5abfcafa":"05124508","chunk-74d8a068":"5301cbfb","chunk-12bcd520":"2cecbc1b","chunk-68bbc849":"201025aa","chunk-cd1faea6":"0a18ad90","chunk-17fa4e38":"a13f31be","chunk-2d0aa995":"31d6cfe0","chunk-2bf51d38":"cca3363d","chunk-6b3b21a4":"21d76abf","chunk-2f416124":"b8cda6e2","chunk-6d21b2ba":"90a7cd2a","chunk-5c8cc8ee":"18b70aff","chunk-36c8e184":"606d67de","chunk-2d22b923":"31d6cfe0","chunk-3493d2b9":"c092b503","chunk-2d0abe78":"31d6cfe0","chunk-04ea26de":"c5d07b25","chunk-70f339e8":"31d6cfe0","chunk-d4ee8400":"b0ee5dec","chunk-76cc7496":"d666a93c","chunk-2d0a4638":"31d6cfe0","chunk-0e579ad4":"38c96679","chunk-28a9a91a":"2f43fc3f","chunk-2c9e7ee5":"31d6cfe0","chunk-2d2084ab":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
